/* React */
import React from "react";

/* React Redux */
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

/* Ionic */
import { IonGrid, IonRow, IonCol } from "@ionic/react";

/* Components */
import LabelContainer from "src/components/admin-dashboard/settings/dev-options-container/label-container/LabelContainer";
import DevModeToggle from "src/components/admin-dashboard/settings/dev-options-container/dev-mode-toggle/DevModeToggle";
import DevOptions from "src/components/admin-dashboard/settings/dev-options-container/dev-options/DevOptions";

/* Utils */
import SettingsWrapper from "src/utils/wrapper/admin-dashboard-wrapper/settings-wrapper/SettingsWrapper";

/* Stylesheet */
import styles from "./DevOptionsContainer.module.scss";

const DevOptionsContainer: React.FC = () => {
  const settingsState = useSelector(
    (state: RootState) => state.settings
  );
  const { devOptions } = settingsState;

  return (
    <SettingsWrapper>
      <LabelContainer
        label={"Dev Options"}
        description={
          "Developer settings for testing and debugging features"
        }
      />
      <IonGrid className={styles.dev_options}>
        <IonRow className={styles.row}>
          <IonCol className={styles.col}>
            <DevModeToggle />
          </IonCol>
          <IonCol className={styles.col}>
            <DevOptions disabled={!devOptions.isDevMode} />
          </IonCol>
        </IonRow>
      </IonGrid>
    </SettingsWrapper>
  );
};

export default DevOptionsContainer;
